import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import { IonContent, NavController, NavParams, Platform } from '@ionic/angular';
import { FormGroup } from '@angular/forms';
import { UploadDocumentService } from 'src/app/services/upload-document/upload-document.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { Navigator } from 'src/app/components/menu/navigator';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { LogoutService } from 'src/app/services/logout/logout.service';
//import { AppLinks } from '../../../../../shared/app-links';

@Component({
  selector: 'app-upload-document',
  templateUrl: './upload-document.component.html',
  styleUrls: ['./upload-document.component.scss'],
})

export class UploadDocumentComponent implements OnInit{

  public error: any = null;
  public fb: FormGroup;
  protected formData: FormData;

  fileObject = {};
  filteredObject = [];
  displayNamePhotoID:string = '';
  displayNameAddress:string = '';
  displayNameFinancials:string = '';
  displayNameOther:string = '';
  displayName:string = '';
  itemSelected:boolean = false;
  clearButtonEnabled:boolean = false;
  isMobile:boolean;
  reconfirmPersonalInfo:boolean = false;

  @ViewChild("fileInput")  fileInput: ElementRef;
  @ViewChild("fileInputAddress")  fileInputAddress: ElementRef;
  @ViewChild("fileInputFinancials") fileInputFinancials: ElementRef;
  @ViewChild("fileInputOther") fileInputOther: ElementRef;
  @ViewChild(IonContent, { static: false }) content: IonContent;

  constructor(
   // public appLinks: AppLinks,
    public navCtrl: NavController,
    public navParams: NavParams,
    public successMessageService: SuccessMessageService,
    private uploadDocumentProvider:UploadDocumentService,
    private navigator:Navigator,
    public platform:Platform,
    protected config: ConfigService,
    private logoutService:LogoutService

  ) {
    this.successMessageService.clearMessage();
    this.error = null;
    this.isMobile = false;
  }

  ngOnInit(){
    this.isMobile = false;
    this.detectMobile();
    this.itemSelected = false;
    this.clearButtonEnabled = false;
    this.fb = new FormGroup({});
    this.formData = new FormData();

  }

  detectMobile() {
    this.platform.ready().then(() => {
        if (this.platform.is('capacitor')) {
          this.isMobile = true;
        } else {
          this.isMobile = false;
        }
    });
}

  onFileChange(event, documenttype) {


    this.fileObject = {};
    this.itemSelected = true;
    this.clearButtonEnabled = true;
    this.successMessageService.clearMessage();
    if(event.target.files && event.target.files.length > 0) {

      this.formData.append(documenttype,event.target.files[0], event.target.files[0].name);
      this.formData.append('document_type',documenttype);

      if(documenttype == 'photo_id'){

        this.displayNamePhotoID =  event.target.files[0].name;

      }
      if(documenttype == 'address'){

        this.displayNameAddress =  event.target.files[0].name;

      }
      if(documenttype == 'financials'){

        this.displayNameFinancials =  event.target.files[0].name;

      }
      if(documenttype == 'other'){

        this.displayNameOther =  event.target.files[0].name;

      }
    }
  }

  onSubmit() {
    this.postData(this.formData);
  }

  postData(formData: FormData){
    this.uploadDocumentProvider.callUploadFile(formData)
      .subscribe(
        (response: any) => {
          if(response.result){
            this.error = null;
            this.successMessageService.setMessage("Your documents have been uploaded.");
            this.content.scrollToTop(10);
            this.formData = new FormData(); //reset formData
            this.clearButtonEnabled = true;
            this.itemSelected = false;
            setTimeout(() => {
              this.clearFileInputsNames();
            }, 3000);

            if (this.navParams.get('reconfirmPersonalInfo')) {
              this.reconfirmPersonalInfo = true;
            }

          }
        },
        (error) => {
          console.error("Upload Documents", error);
          this.error = error;
          switch (error.getErrorCode().toUpperCase()) {
            case 'FILES_REJECTED':
                error.setErrorMessage(error.error_payload.errors[0]);
                break;
                case 'FILE_TOO_LARGE':
                error.setErrorMessage('File is too large. Please try again.');
                break;
            default:
                error.setErrorMessage('An error has occured. Please try again.');
                break;
          }
          this.formData = new FormData();
          this.content.scrollToTop(10);
          this.clearButtonEnabled = true;
          this.itemSelected = false;
          setTimeout(() => {
            this.clearFileInputsNames();
          }, 3000);
        }
      )
  }

  //clear page
  clearFileInputsNames() {
    this.fileInput.nativeElement.value = '';
    this.fileInputAddress.nativeElement.value = '';
    this.fileInputFinancials.nativeElement.value = '';
    this.fileInputOther.nativeElement.value = '';
    this.clearFileNames();
  }
  //clear Inputs, Display Names and Success/Error messages
  clearInputsNamesMessages() {
    this.itemSelected = false;
    this.clearButtonEnabled = false;
    this.error = null;
    this.successMessageService.clearMessage();
    this.clearFileInputsNames();
  }
  //clear file names
  clearFileNames(){
    this.displayNamePhotoID = '';
    this.displayNameAddress = '';
    this.displayNameFinancials = '';
    this.displayNameOther = '';
  }

  closeModal = () => {
    if (this.navParams.get('kycFail')) {
      // User is in KYC Fail status, so log them out
      this.logoutService.onLogout({code: 'INVALID_SESSION_TOKEN', reason: 'QUALIFICATION_KYC_FAIL'});
    } else {
      setTimeout(() => {
        if (this.navParams.get('reconfirmPersonalInfo')) {
          if(this.reconfirmPersonalInfo){
            // this.navigator.navigateTo("LogoutPage", { forceModal: true }, { reason: "RECONFIRMATION_UPLOAD_DOCUMENT_VERIFICATION_PENDING" });
            this.logoutService.callLogout({code: 'INVALID_SESSION_TOKEN', reason: 'RECONFIRMATION_UPLOAD_DOCUMENT_VERIFICATION_PENDING'});
          } else {
            this.logoutService.callLogout({code: 'INVALID_SESSION_TOKEN', reason: 'INCOMPLETE_RECONFIRMATION_UPLOAD_DOCUMENT'});
          }
        } else {
          this.navigator.toLobby();
        }
      }, 0)
    }
  }

  onBack = () => {
    if (this.navParams.get('reconfirmPersonalInfo')) {
      if(this.reconfirmPersonalInfo){
        this.logoutService.callLogout({code: 'INVALID_SESSION_TOKEN', reason: 'RECONFIRMATION_UPLOAD_DOCUMENT_VERIFICATION_PENDING'});
      } else {
        this.logoutService.callLogout({code: 'INVALID_SESSION_TOKEN', reason: 'INCOMPLETE_RECONFIRMATION_UPLOAD_DOCUMENT'});
      }
    } else {
      this.navigator.back();
    }
  }
}
